export const STRINGS = {
  DOMAIN_LABEL: "Reachiq.ai",
  NO_RECORD_FOUND: "No record found",
};
